import { render, staticRenderFns } from "./WABAChannelDetail.vue?vue&type=template&id=59960724&scoped=true"
import script from "./WABAChannelDetail.vue?vue&type=script&lang=js"
export * from "./WABAChannelDetail.vue?vue&type=script&lang=js"
import style0 from "./WABAChannelDetail.vue?vue&type=style&index=0&id=59960724&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59960724",
  null
  
)

export default component.exports